import { render, staticRenderFns } from "./dialogoDetalle.vue?vue&type=template&id=e45ee512"
import script from "./dialogoDetalle.vue?vue&type=script&lang=js"
export * from "./dialogoDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports